import type { ItemContextMetadata } from 'analytics/snowplow/events'

const getOrderCancellationOptionMetadata = (
  orderItem: App.OrderItem,
): ItemContextMetadata | undefined => {
  if (!orderItem.cancellationOptionPolicy) {
    return undefined
  }

  return {
    cancellationOptionPolicy: orderItem.cancellationOptionPolicy,
    cancellationOptionPriceFactor: orderItem.cancellationOptionPriceFactor,
    cancellationOptionBasePrice: orderItem.originalBasePrice,
  }
}

export default getOrderCancellationOptionMetadata
